import { render, staticRenderFns } from "./approvalNotificationDetails.vue?vue&type=template&id=afae858e&scoped=true&"
import script from "./approvalNotificationDetails.vue?vue&type=script&lang=js&"
export * from "./approvalNotificationDetails.vue?vue&type=script&lang=js&"
import style0 from "./approvalNotificationDetails.vue?vue&type=style&index=0&id=afae858e&scoped=true&lang=css&"
import style1 from "./approvalNotificationDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afae858e",
  null
  
)

export default component.exports